const prepareRenewInitialValues = ({ member }) => {
	return {
		plan_type: '',
		first_name: member.first_name,
		last_name: member.last_name,
		email: member.email,
		st_customer_id: member.st_customer_id,
		save_card_information: true
	};
};

export default prepareRenewInitialValues;
